import { useQuery } from '@tanstack/react-query';
import { useSessionStore } from '@/entities/session';
import { useAppSettingsStore } from '@/shared/lib';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';
import { getBankDepositCurrenciesRequest } from '../requests';
import type { BankDepositCurrenciesResponse } from '../types';

export function useBankDepositCurrencies(countryCode: string) {
  const { session } = useSessionStore();
  const { getLanguage } = useAppSettingsStore();
  const locale = getLanguage();

  const query = useQuery<BankDepositCurrenciesResponse, Error>({
    queryKey: ['bankDepositCurrencies', session?.userId, locale, countryCode],
    queryFn: () => getBankDepositCurrenciesRequest(countryCode),
    enabled: !!countryCode,
    staleTime: CACHE_TIME_5_MINUTES,
    gcTime: CACHE_TIME_10_MINUTES,
    retry: 1,
  });

  return {
    currencies: query.data?.currencies ?? [],
    isCurrenciesLoading: query.isLoading,
    isCurrenciesFetching: query.isFetching,
    isCurrenciesError: query.isError,
    currenciesError: query.error,
  };
}
